export default __webpack_public_path__ + "static/media/groupIns.317131da.jpg";